import createLucideIcon from '../createLucideIcon';

const CaseLower = createLucideIcon('CaseLower', [
  ['circle', { cx: '17', cy: '12', r: '3', key: 'gl7c2s' }],
  ['line', { x1: '14', x2: '14', y1: '7', y2: '15', key: '111rms' }],
  ['circle', { cx: '7', cy: '12', r: '3', key: '12clwm' }],
  ['line', { x1: '10', x2: '10', y1: '9', y2: '15', key: '1o5uit' }],
]);

export default CaseLower;
